import moment from 'moment'

export const getDatesBetween = (start: Date, end: Date): string[] => {
  const dateArray = []
  let _start = moment(start)
  const _end = moment(end)
  while (_start <= _end) {
      dateArray.push( moment(_start).format('YYYY-MM-DD') )
      _start = moment(_start).add(1, 'days')
  }
  return dateArray
}